import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./GMIMemberInformationForm.scss";
import { Dropdown } from "react-bootstrap";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function GMIMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [policyNumber] = useState(props.currState.MemberLookup.policyNumber);
  const [vin] = useState(props.currState.MemberLookup.vin);
  const [make] = useState(props.currState.MemberLookup.make);
  const [model] = useState(props.currState.MemberLookup.model);
  const [year] = useState(props.currState.MemberLookup.year);
  const [firstName, setFirstName] = useState(props.context.state.FirstName);
  const [lastName, setLastName] = useState(props.context.state.LastName);
  const [checkDuplicateName, setCheckDuplicateName] = useState(false);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [createContacts, setCreateContact] = useState(["Create a new contact", ""]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleSelectionRadio, setVehicleSelectionRadio] = useState(undefined);

  const [checkContact, setCheckContact] = useState([]);
  const [carMakeList, setCarMakeList] = useState([]);
  const [carMakeSelect, setCarMakeSelect] = useState(undefined);
  const [carModelSelect, setCarModelSelect] = useState(undefined);
  const [carYearSelect, setCarYearSelect] = useState(undefined);
  const [showVehicleSelection, setShowVehicleSelection] = useState(false);
  const [filteredVehicleList, setFilteredVehicleList] = useState([]);

  const [uniqueMakes, setUniqueMakes] = useState([]);
  const [uniqueModels, setUniqueModels] = useState([]);
  const [uniqueYears, setUniqueYears] = useState([]);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  const [displayConfirmation, setDisplayConfirmation] = useState(false);

  useEffect(() => {
    //devLog(props);
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // //devLog("run useEffect", checkDuplicateName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // //devLog("run useEffect", checkDuplicateName);
  }, [contacts]);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onMemberInfo = (vehicleInfo) => {
    if (typeof props.onMemberVehicle === "function") {
      props.onMemberVehicle(vehicleInfo);
    }
  };

  const makeDisplay = (memberInfo) => {
    let makes = new Set();
    let uniMakes = [];
    if (memberInfo.length > 1) {
      setSelectedVehicle(null);
      memberInfo.map((member, index) => {
        if (!makes.has(member.make)) {
          makes.add(member.make);
          uniMakes.push(member.make);
        }
      });
      uniMakes.sort((a, b) => a.localeCompare(b));
      setUniqueMakes(uniMakes);
      // //devLog("uniMakes: ", uniMakes);
    } else {
      setSelectedVehicle(memberInfo[0]);
      onMemberInfo(memberInfo[0]);
    }
  };

  const modelDisplay = (carMakeSelect, memberInfo) => {
    const models = new Set();
    if (typeof memberInfo === "undefined" || !carMakeSelect) {
      return;
    }
    memberInfo.map((member, index) => {
      if (member.make === carMakeSelect) {
        models.add(member.model);
      }
    });
    const uniModels = Array.from(models).sort((a, b) => a.localeCompare(b));
    setUniqueModels(uniModels);
    // //devLog("uniModels: ", uniModels);
  };

  const yearDisplay = (carModelSelect, memberInfo) => {
    const years = new Set();
    if (typeof memberInfo === "undefined" || !carModelSelect) {
      return;
    }
    memberInfo.map((member, index) => {
      if (member.model === carModelSelect) {
        years.add(member.year);
      }
    });
    const uniYears = Array.from(years).sort((a, b) => a.localeCompare(b));
    setUniqueYears(uniYears);
    // //devLog("uniModels: ", uniYears);
  };

  useEffect(() => {
    modelDisplay(carMakeSelect, memberInfo);
  }, [carMakeSelect]);

  useEffect(() => {
    yearDisplay(carModelSelect, memberInfo);
  }, [carModelSelect]);

  useEffect(() => {
    if (!!carMakeSelect && !!carModelSelect && !!carYearSelect) {
      const newList = memberInfo.filter((vehicle) => {
        return vehicle.make === carMakeSelect && vehicle.year === carYearSelect && vehicle.model === carModelSelect;
      });
      setFilteredVehicleList(newList);
      setShowVehicleSelection(true);
    } else {
      setFilteredVehicleList([]);
      setSelectedVehicle(null);
      setShowVehicleSelection(false);
    }
  }, [carMakeSelect, carModelSelect, carYearSelect]);

  useEffect(() => {
    setSelectedVehicle(null);
    setCarModelSelect(undefined);
    setCarYearSelect(undefined);
    setVehicleSelectionRadio(false);
    setUniqueYears([]);
  }, [carMakeSelect]);

  useEffect(() => {
    setSelectedVehicle(null);
    setCarYearSelect(undefined);
    setVehicleSelectionRadio(false);
  }, [carModelSelect]);

  useEffect(() => {
    setSelectedVehicle(null);
    setVehicleSelectionRadio(false);
  }, [carYearSelect]);

  //select Contact function, set selectContact to contactInfo => input
  //
  // const onSelect = (sc) => {
  //   //devLog("selected Contact: ", sc);
  //   setSelectedContact(sc);
  //   onMemberInfo(memberInfo, sc);
  //   if (sc === undefined) {
  //     //devLog(
  //       "selected undefined Contact: ",
  //       props.context.state.FirstName + " " + props.context.state.LastName
  //     );
  //     setFirstName(props.context.state.FirstName);
  //     setLastName(props.context.state.LastName);
  //   } else {
  //     setFirstName(sc.firstName);
  //     setLastName(sc.lastName);
  //     //devLog(
  //       "selected defined Contact: ",
  //       sc.firstName + " " + sc.lastName
  //     );
  //   }
  // };

  const onSelect = (v) => {
    //devLog("selected Vehicle: ", v);
    setVehicleSelectionRadio(v);
    setDisplayConfirmation(true);
    onMemberInfo(v);
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        searchType: searchType,
        policyNumber: policyNumber,
        last8Vin: last8Vin,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        //devLog("JSON", json);
        if (typeof json.data.memberInfo === "object") {
          if (!json.data.error) {
            makeDisplay(json.data.memberInfo);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const checkDuplicateContact = (firstName, lastName) => {
    contacts.map((con, index) => {
      if (
        con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
        con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
      ) {
        setCheckDuplicateName(true);
      }
      return checkDuplicateContact;
    });
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo.length > 1 ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.VehicleInformationHeader")}</h4>
              <hr />
              <div className="vehicle-info-line">
                <b className="bCar">{t("ATF.PolicyInformation.ConfirmCustomerMake")}:</b>
                {/* {memberInfo[0].make ? memberInfo[0].make : ""} */}
                <Dropdown className="make-dropdown" id="dropdown-Primary">
                  <Dropdown.Toggle style={{ color: "black" }} variant="light" id="dropdown-basic" title="Make">
                    {carMakeSelect ? carMakeSelect : "Please make a selection"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu variant="light" className="dropdown-menu">
                    {uniqueMakes.map((make, index) => {
                      return (
                        <Dropdown.Item
                          className="dropdown-item"
                          active={make === carMakeSelect}
                          onClick={
                            (e) => setCarMakeSelect(make)

                            // check(e.value);l
                          }
                        >
                          {make}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <hr />
              <div className="vehicle-info-line">
                <b className="bCar">{t("ATF.PolicyInformation.ConfirmCustomerModel")}:</b>
                {/* {memberInfo[0].model ? memberInfo[0].model : ""} */}
                <Dropdown className="make-dropdown" id="dropdown-Primary">
                  <Dropdown.Toggle style={{ color: "black" }} variant="light" id="dropdown-basic" title="Model">
                    {carModelSelect ? carModelSelect : "Please make a selection"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu variant="light" className="dropdown-menu">
                    {uniqueModels.map((model, index) => {
                      return (
                        <Dropdown.Item
                          className="dropdown-item"
                          active={model === carModelSelect}
                          onClick={(e) => setCarModelSelect(model)}
                        >
                          {model}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <hr />
              <div className="vehicle-info-line">
                <b className="bCar">{t("ATF.PolicyInformation.ConfirmCustomerYear")}:</b>
                {/* {memberInfo[0].model ? memberInfo[0].model : ""} */}
                <Dropdown className="make-dropdown" id="dropdown-Primary-down">
                  <Dropdown.Toggle style={{ color: "black" }} variant="light" id="dropdown-basic" title="Year">
                    {carYearSelect ? carYearSelect : "Please make a selection"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu variant="light" className="dropdown-menu" direction="down">
                    {uniqueYears.map((year, index) => {
                      return (
                        <Dropdown.Item
                          className="dropdown-item"
                          active={year === carYearSelect}
                          onClick={(e) => setCarYearSelect(year)}
                        >
                          {year}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )}

        {selectedVehicle ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.VehicleInformationHeader")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerMake")}: </b>
                {selectedVehicle.make ? selectedVehicle.make : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerModel")}: </b>
                {selectedVehicle.model ? selectedVehicle.model : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerYear")}: </b>
                {selectedVehicle.year ? selectedVehicle.year : ""}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )}

        {showVehicleSelection && (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.VehicleSelectionHeader")}</h4>
              <div style={{ fontSize: ".8rem" }}>Make | Model | Year | Last 8 Digits of VIN</div>
              <hr />

              {filteredVehicleList.map((vehicle, index) => {
                return (
                  <div
                    key={index}
                    value={vehicle}
                    className={`vehicle-list-item ${vehicleSelectionRadio === vehicle ? "selected" : ""}`}
                    onClick={(e) => {
                      onSelect(vehicle);
                    }}
                  >
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={vehicleSelectionRadio === vehicle ? "selected" : ""}
                        required={true}
                      />
                      <div value={vehicle} className="vehicle-list-item-col-1">
                        <h6 value={vehicle} className="name-h6" style={{ marginLeft: "5px" }}>
                          {vehicle.make} | {vehicle.model} | {vehicle.year} | {vehicle.vin}
                        </h6>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* {vehicleSelectionRadio ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.VehicleConfirmationHeader")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerMake")}:</b>{" "}
                {vehicleSelectionRadio.make ? vehicleSelectionRadio.make : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerModel")}:</b>{" "}
                {vehicleSelectionRadio.model ? vehicleSelectionRadio.model : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerYear")}:</b>{" "}
                {vehicleSelectionRadio.year ? vehicleSelectionRadio.year : ""}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )} */}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default GMIMemberInformationForm;
